import { render, staticRenderFns } from "./ckeditor.vue?vue&type=template&id=0bc8d126"
import script from "./ckeditor.vue?vue&type=script&lang=js"
export * from "./ckeditor.vue?vue&type=script&lang=js"
import style0 from "./ckeditor.vue?vue&type=style&index=0&id=0bc8d126&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports